export default __webpack_public_path__ + "static/media/icon_corporate.83031552.svg";